import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './footer.html'
})
export class Footer {
  environmentName = environment.EnvironmentPlaceName;
}
